import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7531 6.0891C15.0006 5.44463 15.7236 5.1228 16.3681 5.37028L22.3081 7.65128C22.9525 7.89874 23.2743 8.62169 23.027 9.26614L20.747 15.2061C20.4996 15.8506 19.7766 16.1726 19.1321 15.9252C18.4876 15.6778 18.1656 14.9548 18.413 14.3103L19.6116 11.1876C17.3661 12.1872 15.533 13.9295 14.4207 16.1218C14.2395 16.4789 13.8981 16.7276 13.5026 16.7906C13.1071 16.8536 12.7053 16.7233 12.4221 16.4401L9 13.018L3.13388 18.8841C2.64573 19.3722 1.85427 19.3722 1.36612 18.8841C0.877961 18.3959 0.877961 17.6045 1.36612 17.1163L8.11612 10.3663C8.60427 9.87816 9.39573 9.87816 9.88388 10.3663L13.0517 13.5342C14.4269 11.5143 16.3429 9.90605 18.5953 8.90352L15.4719 7.70412C14.8274 7.45664 14.5056 6.73357 14.7531 6.0891Z"
        fill={colorValue}
      />
    </svg>
  );
};
